import { Component, OnInit, ContentChildren, QueryList, AfterContentInit } from '@angular/core';
import { UiPanelComponent } from './ui-panel.component';

@Component({
    selector: 'ui-panel-list',
    template: 
        `	<div class="panel-list">
                <ng-content></ng-content>
            </div>        
        `,
    host: {
    }
})

export class UiPanelList implements OnInit, AfterContentInit {   
    @ContentChildren(UiPanelComponent) panels: QueryList<UiPanelComponent>;
    expandedPanel: UiPanelComponent = null;

	constructor() {
    }

    ngAfterContentInit() {
        this.panels.changes.subscribe(()=> {
            this.init();
        })
        
        this.init();
    }

    init() {
        this.expandedPanel = null;
        this.panels.toArray().forEach((panel) => {
            panel.toggle.subscribe(() => {
                if(this.expandedPanel !== panel && this.expandedPanel) {
                    this.expandedPanel.closePanel();
                }
                this.expandedPanel = panel;
            });
        });
    }
    ngOnInit(){
    }

}


